// src/components/UI/LoadingOverlay.tsx
import React from 'react';
import { motion } from 'framer-motion';

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  isVisible, 
  message = 'Loading...' 
}) => {
  if (!isVisible) return null;
  
  return (
    <motion.div 
      className="fixed inset-0 z-[20000] bg-black/40 backdrop-blur-sm flex items-center justify-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        backgroundColor: 'var(--overlay-bg-color, rgba(0, 0, 0, 0.4))',
        backdropFilter: 'var(--overlay-blur, blur(4px))'
      }}
    >
      <div className="bg-white rounded-lg shadow-xl" style={{
        padding: 'var(--loading-container-padding, 1.5rem)',
        borderRadius: 'var(--loading-container-radius, 0.5rem)',
        boxShadow: 'var(--loading-container-shadow, 0 10px 15px -3px rgba(0, 0, 0, 0.1))'
      }}>
        <div className="flex items-center" style={{
          gap: 'var(--loading-content-gap, 1rem)'
        }}>
          <div className="animate-spin border-4 border-blue-500 border-t-transparent rounded-full" style={{
            height: 'var(--loading-spinner-size, 2rem)',
            width: 'var(--loading-spinner-size, 2rem)',
            borderWidth: 'var(--loading-spinner-border, 4px)',
            borderColor: 'var(--loading-spinner-color, #3b82f6)',
            borderTopColor: 'transparent'
          }}></div>
          <span style={{
            fontSize: 'var(--loading-text-size, .75.rem)',
            fontWeight: 'var(--loading-text-weight, normal)'
          }}>{message}</span>
        </div>
      </div>
    </motion.div>
  );
};

/* export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  isVisible, 
  message = 'Loading...' 
}) => {
  if (!isVisible) return null;
  
  return (
    <motion.div 
      className="fixed inset-0 z-[9999] bg-black/40 backdrop-blur-sm flex items-center justify-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="bg-white p-6 rounded-lg shadow-xl">
        <div className="flex items-center space-x-4">
          <div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full"></div>
          <span className="text-lg">{message}</span>
        </div>
      </div>
    </motion.div>
  );
}; */